export enum AlertTypes {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
}

export interface CardStyleDefinition {
  cardBg: string;
  descriptionText: string;
  infoText: string;
  buttonStyle: string;
}
